const TOKEN_KEY = "jwt";
const USER_NAME = "name";
const USER_DEPARTMENT = "department";
const EMPLOYEE_ID = "emptId";
const USER_CODE = "userCode";
const DEPARTMENT_ID = "departmentId";
const EMPLOYEE_NAME = "empName";
const USER_ID = "userId";
const USER_ROLE = "userRole";
const EMPLOYEE_CODE = "empCode";

export const login = (
  token,
  name,
  department,
  empId,
  userCode,
  departmentId,
  empName,
  userId,
  userRole,
  empCode
) => {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_NAME, name);
  localStorage.setItem(USER_DEPARTMENT, department);
  localStorage.setItem(EMPLOYEE_ID, empId);
  localStorage.setItem(USER_CODE, userCode);
  localStorage.setItem(DEPARTMENT_ID, departmentId);
  localStorage.setItem(EMPLOYEE_NAME, empName);
  localStorage.setItem(USER_ID, userId);
  localStorage.setItem(USER_ROLE, userRole);
  localStorage.setItem(EMPLOYEE_CODE, empCode);
  console.log("login");
  console.log(
    localStorage.getItem(TOKEN_KEY),
    localStorage.getItem(USER_NAME),
    localStorage.getItem(USER_DEPARTMENT),
    localStorage.getItem(EMPLOYEE_ID),
    localStorage.getItem(USER_CODE)
  );
};

export const logout = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_NAME);
  localStorage.removeItem(USER_DEPARTMENT);
  localStorage.removeItem(EMPLOYEE_ID);
  localStorage.removeItem(USER_CODE);
  localStorage.removeItem(DEPARTMENT_ID);
  localStorage.removeItem(EMPLOYEE_NAME);
  localStorage.removeItem(USER_ID);
  localStorage.removeItem(USER_ROLE);
  localStorage.removeItem(EMPLOYEE_CODE);
  console.log("logout");
  console.log(
    localStorage.getItem(TOKEN_KEY),
    localStorage.getItem(USER_NAME),
    localStorage.getItem(USER_DEPARTMENT),
    localStorage.getItem(EMPLOYEE_ID),
    localStorage.getItem(USER_CODE)
  );
};

export const isLogin = () => {
  if (localStorage.getItem(TOKEN_KEY)) {
    return true;
  }
  return false;
};

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const getUserInfo = () => {
  return {
    name: localStorage.getItem(USER_NAME),
    department: localStorage.getItem(USER_DEPARTMENT),
    empId: localStorage.getItem(EMPLOYEE_ID),
    userCode: localStorage.getItem(USER_CODE),
    departmentId: localStorage.getItem(DEPARTMENT_ID),
    empName: localStorage.getItem(EMPLOYEE_NAME),
    userId: localStorage.getItem(USER_ID),
    userRole: localStorage.getItem(USER_ROLE),
    empCode: localStorage.getItem(EMPLOYEE_CODE),
  };
};
